/* eslint-disable */
import Swiper from 'swiper/bundle';


var swiper = new Swiper('.swiper-blog-container', {
  slidesPerView: 1.4,
  spaceBetween: 28,
  navigation: {
    nextEl: '.blog__cards .wrapper-nav .next',
    prevEl: '.blog__cards .wrapper-nav .prev',
  },
  breakpoints: {
    // 560: {
    //   slidesPerView: 1.5
    // },
    768: {
      slidesPerView: 2.1
    },
    1199: {
      slidesPerView: 3
    }
  }
});

  const floatingBtn = document.querySelector('.floating-contact-btn');

  floatingBtn.onclick = function() {
    const insideMenu = this.querySelector('ul.inside-floating-contact-btn');

    [this, insideMenu].forEach(el => el.classList.add('show-icons'));

    const closeFloating = this.querySelector('.close-floating');

    closeFloating.onclick = (e) => {
      e.stopPropagation();
      [this, insideMenu].forEach(el => el.classList.remove('show-icons'));
    }
  }



// WEBPACK FOOTER //
// ./scripts/common.js